import { render } from "./ListeForum.vue?vue&type=template&id=62a84f2e&ts=true"
import script from "./ListeForum.vue?vue&type=script&lang=ts"
export * from "./ListeForum.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__